import * as React from 'react';

import Popup from 'components/src/popup';

type Props = {
  showSuccessModal: boolean;
  setShowSuccessModal: React.Dispatch<React.SetStateAction<boolean>>;
};

const SuccessModal = ({ showSuccessModal, setShowSuccessModal }: Props) => {
  return (
    <Popup
      isOpen={showSuccessModal}
      title={'Takk fyrir'}
      text={'Greiðsla tókst og við höfum fyllt á símann.'}
      buttonText={'Loka glugga'}
      variant={'content'}
      onClose={() => setShowSuccessModal(false)}
      onClick={() => setShowSuccessModal(false)}
    />
  );
};
export default SuccessModal;
